module.exports = __webpack_public_path__ + "static/media/halo-massage.bebd856e.svg";